import auth from './modules/auth'
import main from './modules/main'
import permohonan from './modules/permohonan'
import user from './modules/user'
import penduduk from './modules/penduduk'
import akun from './modules/akun'
import paket from './modules/paket'
import layanan from './modules/layanan'
import form from './modules/form'
import kabupaten from './modules/kabupaten'
import kecamatan from './modules/kecamatan'
import desa from './modules/desa'
import dokumen from './modules/dokumen'
import berita from './modules/berita'
import panduan from './modules/panduan'
import dashboard from './modules/dashboard'
import report from './modules/report'
import page from './modules/page'
import file from './modules/file'
import shdk from './modules/shdk'
import notifikasi from './modules/notifikasi'
import log from './modules/log'
import formBiodata from './modules/form/biodata'
import formBiodataWni from './modules/form/biodataWni'
import formPelaporan from './modules/form/pelaporan'
import formPendaftaranKependudukan from './modules/form/pendaftaranKependudukan'
import formPendaftaranPerpindahanPenduduk from './modules/form/pendaftaranPerpindahanPenduduk'
import formSkPindahLuarNegeri from './modules/form/skPindahLuarNegeri'
import formSpPerubahanData from './modules/form/spPerubahanData'
import formSpTidakMemilikiDokumen from './modules/form/spTidakMemilikiDokumen'
import formSptjmKawinBelumCatat from './modules/form/sptjmKawinBelumCatat'
import formSptjmKelahiran from './modules/form/sptjmKelahiran'
import formSptjmSuamiIstri from './modules/form/sptjmSuamiIstri'
import formPendudukNonPermanen from './modules/form/pendudukNonPermanen'
import menuumkm from './modules/menuumkm'
import umkm from './modules/umkm'
import pesanan from './modules/pesanan'

const state = {
	state: {
	},
	mutations: {
	},
	actions: {
	},
	modules: {
		main, auth, permohonan, user, penduduk,
		akun, paket, layanan, form, kabupaten,
		kecamatan, desa, dokumen, berita, report,
		page, notifikasi, shdk, dashboard, panduan, file,
		formBiodata, formBiodataWni, formPelaporan, log,
		formPendaftaranKependudukan, formPendaftaranPerpindahanPenduduk,
		formSkPindahLuarNegeri, formSpPerubahanData, formSpTidakMemilikiDokumen,
		formSptjmKawinBelumCatat, formSptjmKelahiran, formSptjmSuamiIstri, formPendudukNonPermanen,
    menuumkm, pesanan, umkm

	}
}
export default state